import { parseMoney } from './money';

export interface ItemFormValues {
  name: string;
  price: string;
  link: string;
  /** Target price of the price alert; empty for none. */
  target?: string;
}

export type ItemFormError = { field: 'name' | 'price' | 'link' | 'target'; message: string };

/** Same checks and wording as the artifact's item sheet, plus a link check the server enforces anyway. */
export function validateItemForm(v: ItemFormValues): ItemFormError | null {
  if (!v.name.trim()) return { field: 'name', message: 'Gib dem Teil einen Namen.' };
  if (Number.isNaN(parseMoney(v.price)))
    return { field: 'price', message: 'Der Preis sieht nicht wie eine Zahl aus, z. B. 49,90.' };
  const link = v.link.trim();
  if (link && !isHttpUrl(link))
    return { field: 'link', message: 'Der Link muss mit https:// oder http:// anfangen.' };
  if (Number.isNaN(parseMoney(v.target)))
    return { field: 'target', message: 'Der Zielpreis sieht nicht wie eine Zahl aus, z. B. 39,90.' };
  return null;
}

export function isHttpUrl(s: string): boolean {
  try {
    const u = new URL(s);
    return (u.protocol === 'https:' || u.protocol === 'http:') && !!u.host;
  } catch {
    return false;
  }
}
